import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import TelegramIcon from '@mui/icons-material/Telegram';
import PublicIcon from '@mui/icons-material/Public';
import TerminalIcon from '@mui/icons-material/Terminal';
import AppSettingsAltIcon from '@mui/icons-material/AppSettingsAlt';
import Awede1 from '../assets/images/Awede1.jpg'
import Awede2 from '../assets/images/Awede2.jpg'
import Awede3 from '../assets/images/Awede3.jpg'
import Awede4 from '../assets/images/Awede4.jpg'
import Awede5 from '../assets/images/Awede5.jpg'
import Chatgpt from '../assets/images/Chatgpt.jpg'
import Chatgpt1 from '../assets/images/Chatgpt1.jpg'
import Chatgpt3 from '../assets/images/Chatgpt3.jpg'
import Chatgpt4 from '../assets/images/Chatgpt4.jpg'
import ReactT from '../assets/images/React.jpg'
import React1 from '../assets/images/React1.jpg'
import React2 from '../assets/images/React2.jpg'
import React3 from '../assets/images/React3.jpg' 
import React5 from '../assets/images/React5.png'
import React6 from '../assets/images/React6.png'
import React7 from '../assets/images/React7.png'
import Aikitchenapp from '../assets/images/aikitchenapp.png'
import Aikitchenapp1 from '../assets/images/aikitchenapp1.png'
import Aikitchenapp2 from '../assets/images/aikitchenapp2.png'
import Aikitchenapp3 from '../assets/images/aikitchenapp3.jpg'
import Shelf from '../assets/images/Shelf.jpg'
import Shelf1 from '../assets/images/Shelf1.jpg'
import Shelf2 from '../assets/images/Shelf3.jpg'
import Shelf3 from '../assets/images/Shelf4.jpg'
import Shelf4 from '../assets/images/Shelf5.jpg'
import Shelf5 from '../assets/images/Shelf6.jpg'
import Velro from '../assets/images/Velro.png'
import Velro1 from '../assets/images/Velro1.png'
import Velro2 from '../assets/images/Velro2.png'
import AbetElectronics from '../assets/images/AbetElectronics.jpg'
import AbetElectronics1 from '../assets/images/AbetElectronics1.jpg'
import AbetElectronics2 from '../assets/images/AbetElectronics2.jpg'
import AbetElectronics3 from '../assets/images/AbetElectronics3.jpg'
import Salesapp from '../assets/images/Salesapp1.jpg'
import Salesapp1 from '../assets/images/Salesapp.jpg'
import Salesapp2 from '../assets/images/Salesapp2.jpg'
import Salesapp3 from '../assets/images/Salesapp3.jpg'
import Salesapp4 from '../assets/images/Salesapp4.jpg'
import Salesapp5 from '../assets/images/Salesapp5.jpg'
import Salesapp6 from '../assets/images/Salesapp6.jpg'
import Salesapp7 from '../assets/images/Salesapp7.jpg'
import Telegram1 from '../assets/images/Telegram1.jpg'
import Telegrambot from '../assets/images/Telegrambot.jpg'
import Telegrambot2 from '../assets/images/Telegrambot2.jpg'
import Telegrambot3 from '../assets/images/Telegrambot3.jpg'
import Telegrambot4 from '../assets/images/Telegrambot4.jpg'
import Todo from '../assets/images/Todo.jpg'
import Todo1 from '../assets/images/Todo1.jpg'
import Todo2 from '../assets/images/Todo2.jpg'
import Todo3 from '../assets/images/Todo3.jpg'
import Todo4 from '../assets/images/Todo4.jpg'
import Todo5 from '../assets/images/Todo5.jpg'
  export default{
    name:'Abrham Tesfaye',
    profession:'Full-Stack Mobile & Web Engineer',
    birthday:'28 August 1999',
    email:'aberhamtesfaye@gmail.com',
    phoneNumber:'+251922346685',
    address:'Addis Ababa, Ethiopia',
    socials:{
        LinkedIn:{
            link:"https://www.linkedin.com/in/abrham-tesfaye-13541a19a",
            text:"abrham@linkedIn",
            icon:<LinkedInIcon/>
        },
        Github:{
            link:"https://github.com/ab2230",
            text:"abrham@github",
            icon:<GitHubIcon/>
        },
        Telegram:{
            link:"https://t.me/abthehuman",
            text:'abrham@telegram',
            icon:<TelegramIcon/>
        }
    },
    about:"Full-Stack Mobile & Web Engineer with 5+ years of experience building and deploying scalable mobile and web applications using React Native, Node.js, and modern JavaScript frameworks. Proven track record of delivering production-ready apps to the Google Play Store and Apple App Store, including real-time systems, payment integrations, and subscription-based platforms. Experienced in leading development teams and building end-to-end solutions from scratch.",
  
    educations:[
        {
            title:"Master's Degree in Software Engineering",
            date:'Addis Ababa Science and Technology University',
            description:'Advanced studies in software engineering, focusing on scalable systems and modern development practices.'
        },
        {
            title:"Bachelor's Degree in Software Engineering",
            date:'2018-2022',
            description:'Graduated with CGPA: 3.75 from Addis Ababa Science and Technology University',
            honors:'Graduated with a very great distinction'
        },
        {
            title:'Front-End Web Development with React',
            date:'Coursera - Hong Kong University of Science and Technology',
            description:'Completed online certification course in React development'
        },
        {
            title:'Machine Learning',
            date:'Coursera - Stanford University',
            description:'Completed machine learning certification including advanced learning algorithms'
        }
    ],
    
    experiences:[
        {
            title:'Lead Full-Stack Mobile Engineer',
            company:'AddisSystems',
            date:'Oct 2024 – Present',
            description:'Led development of a real-time inventory management mobile application (React Native + Node.js). Rebuilt legacy codebase into a scalable architecture and migrated reusable components. Implemented subscription system with free and premium tiers. Integrated payment solution and real-time updates using WebSockets.',
            link:'https://play.google.com/store/apps/details?id=com.mposapp&hl=en'
        },
        {
            title:'Lead Full-Stack Mobile Engineer',
            company:'Velro (Remote Part-time)',
            date:'Jun 2025 – Aug 2025',
            description:'Built a cross-border delivery platform connecting travelers and senders. Led mobile app development from scratch using React Native. Developed real-time messaging and notification system. Deployed application to both App Store and Google Play Store.',
            link:'https://apps.apple.com/il/app/velro/id6753633447'
        },
        {
            title:'IT Systems Professional',
            company:'Commercial Bank of Ethiopia',
            date:'Jan 2023 – Jan 2025',
            description:'Worked on mobile banking, ATM systems, and POS infrastructure. Monitored and reported ATM system performance and operations. Participated in deployment of ITM (Interactive Teller Machine) system.'
        },
        {
            title:'Mobile App Developer',
            company:'July-23rd-Technologies (Remote Part-Time)',
            date:'Feb 2023 – Feb 2024',
            description:'Developed sales management application using React Native and Firebase. Built dashboards with data visualization and analytics. Implemented authentication and state management using Redux.'
        },
        {
            title:'ERP Deployment Engineer',
            company:'Ken Techno',
            date:'Mar 2022 – Jan 2023',
            description:'Deployed and configured ERP systems on Linux servers. Set up remote access and networking configurations. Gathered requirements and designed system workflows for clients.'
        }
    ],

    services:[
        {
            title:'Mobile App Development',
            description:'Building production-ready mobile applications using React Native and Expo, deployed to both Google Play Store and Apple App Store with real-time features and payment integrations',
            icon:<AppSettingsAltIcon/>
        },
        {
            title:'Full-Stack Development',
            description:'Developing scalable web applications using React, Next.js, Node.js, and Express with modern architecture patterns and best practices',
            icon:<PublicIcon/>
        },
        {
            title:'Backend & Cloud Services',
            description:'Building robust backend systems with Node.js, Firebase Cloud Functions, WebSockets for real-time updates, and REST APIs',
            icon:<TerminalIcon/>
        }
    ],

    skills:[
        {
            title:'MOBILE & FRONTEND',
            descriptions:[
                "React Native",
                "React",
                "Next.js",
                "Expo",
                "TypeScript",
                "JavaScript",
                "Redux"
            ]
        },
        {
            title:'BACKEND',
            descriptions:[
                "Node.js",
                "Express",
                "Firebase",
                "Cloud Functions",
                "WebSockets",
                "REST APIs"
            ]
        },
        {
            title:'DATABASES',
            descriptions:[
                "MongoDB",
                "MySQL",
                "Firestore",
                "Postgresql"
            ]
        },
        {
            title:'LANGUAGES',
            descriptions:[
                "JavaScript",
                "TypeScript",
                "Python",
                "PHP"
            ]
        },
        {
            title:'TOOLS & DEPLOYMENT',
            descriptions:[
                "Git",
                "Play Console",
                "App Store Connect",
                "SCRUM/Agile"
            ]
        }
    ],
    projects: [
        {
            tag: 'React-Native',
            images: [
                Shelf,
                Shelf1,
                Shelf2,
                Shelf3,
                Shelf4,
                Shelf5,
            ],
            title: 'Real-Time Inventory Management App',
            caption: 'Production mobile app with subscription system',
            description: 'Led development of a real-time inventory management mobile application using React Native and Node.js. Rebuilt legacy codebase into scalable architecture. Implemented subscription system with free and premium tiers, payment integration, and real-time updates using WebSockets. Deployed to Google Play Store.',
            links: [
                {
                link:'https://play.google.com/store/apps/details?id=com.mposapp&hl=en',
                icon: <PublicIcon/>
                }
            ]
        },
        {
            tag: 'React-Native',
            images: [
                Velro,
                Velro1,
                Velro2,
            ],
            title: 'Velro - Cross-Border Delivery Platform',
            caption: 'Connecting travelers and senders worldwide',
            description: 'Built a cross-border delivery platform from scratch using React Native. Developed real-time messaging and notification system. Successfully deployed to both App Store and Google Play Store.',
            links: [
                {
                link:'https://apps.apple.com/il/app/velro/id6753633447',
                icon: <PublicIcon/>
                },
                {
                link:'https://play.google.com/store/apps/details?id=velro.velro.com&pli=1',
                icon: <PublicIcon/>
                }
            ]
        },
        {
            tag: 'React-Native',
            images: [
                Aikitchenapp1,
                Aikitchenapp,
                Aikitchenapp2,
                Aikitchenapp3
            ],
            title: 'AI Kitchen Chef',
            caption: 'AI-powered recipe generation app',
            description: 'Built AI-powered mobile app that generates recipes from ingredients using text and image input. Integrated image recognition and AI-based recipe generation. Implemented authentication, subscriptions, and scalable backend with Firebase.',
            links: [
                {
                link:'https://apps.apple.com/us/app/ai-kitchen-chef/id6740346503',
                icon: <PublicIcon/>
                }
            ]
        },
        {
            tag: 'React',
            images: [
                AbetElectronics,
                AbetElectronics1,
                AbetElectronics2,
                AbetElectronics3
            ],
            title: 'Abet Electronics - E-commerce Platform',
            caption: 'Full-stack e-commerce solution',
            description: 'Developed mobile app (React Native) and web frontend (React) with Node.js + MySQL backend. Implemented cart, orders, authentication, and real-time updates. Supported multilingual UI and dark/light themes.',
            links: [
                {
                link:'https://abetelectronics.com/',
                icon: <PublicIcon/>
                },
                {
                link:'https://abetelectronics.com/android/abet%20electronics.apk',
                icon: <PublicIcon/>
                }
            ]
        },
        {
            tag: 'React-Native',
            images: [
                Salesapp,
                Salesapp1,
                Salesapp2,
                Salesapp3,
                Salesapp4,
                Salesapp5,
                Salesapp6,
                Salesapp7
            ],
            title: 'Sales Management System',
            caption: 'Firebase-powered sales tracking app',
            description: 'Developed sales management application using React Native and Firebase. Built dashboards with data visualization and analytics. Implemented authentication and state management using Redux.',
            links: [
                {
                link:'https://github.com/July-23rd-Technologies/Megenagna.git',
                icon: <GitHubIcon/>
                }
            ]
        },
        {
            tag: 'React',
            images: [
                Awede1,
                Awede2,
                Awede3,
                Awede4,
                Awede5
            ],
            title: 'Awede Admin Dashboard',
            caption: 'Music streaming platform admin panel',
            description: 'Admin dashboard for uploading audio files and lyrics for Awede, a music, podcast and audiobook streaming platform. Built with React for efficient content management.',
            links: [
                {
                link:'https://github.com/ab2230/Admin-DashBoard.git',
                icon: <GitHubIcon/>
                }
            ]
        },
        {
            tag: 'React-Native',
            images: [
                Todo,
                Todo1,
                Todo2,
                Todo3,
                Todo4,
                Todo5
            ],
            title: 'Simple TODO App using React-Native',
            caption: 'A user-friendly TODO app',
            description: 'This is simple To-Do app, designed to help stay organized and on track. With the app, user can easily create and manage tasks, set reminders, and priortize their to-do list.',
            links: [
                {
                link:'https://github.com/KingAdonay/Todo.git',
                icon: <GitHubIcon/>
                },
            ]
        },
        {
            tag: 'React',
            images: [
                Chatgpt,
                Chatgpt1,
                Chatgpt3,
                Chatgpt4
            ],
            title: 'ChatGPT Web Interface',
            caption: 'AI chat application with model selection',
            description: 'Web application to access ChatGPT with selection of different AI models. Built with React frontend and Node.js backend for seamless AI interactions.',
            links: [
                {
                link:'https://github.com/ab2230/abChatGPT-front-end.git',
                icon: <GitHubIcon/>
                },
                {
                link:'https://ab-chatgpt-client.onrender.com/',
                icon: <PublicIcon/>
                },
                {
                link:'https://github.com/ab2230/chat-GPT-SERVER.git',
                icon: <GitHubIcon/>
                }
            ]
        },
        {
            tag: 'React',
            images: [
                React7,
                React6,
                React5,
                ReactT,
                React1,
                React2,
                React3
            ],
            title: 'Restaurant Management System',
            caption: 'Full-featured restaurant web platform',
            description: 'Restaurant management web application with food and drink services, rating system, and customer reviews. Built with React and modern web technologies.',
            links: [
                {
                link:'https://github.com/ab2230/React-confusion.git',
                icon: <GitHubIcon/>
                },
                {
                link:'https://626595c0e6c8985e08edd7c3--tiny-pegasus-b8b509.netlify.app/home',
                icon: <PublicIcon/>
                }
            ]
        },
        {
            tag: 'Python',
            images: [
                Telegram1,
                Telegrambot,
                Telegrambot2,
                Telegrambot3,
                Telegrambot4
            ],
            title: 'Telegram Bot',
            caption: 'Automated file management bot',
            description: 'Telegram bot built with Python that allows users to upload and manage files in a database. Automated file posting and retrieval system.',
            links: [
                {
                link:'https://github.com/ken-techno1234/Telegram-bot.git',
                icon: <GitHubIcon/>
                }
            ]
        },
        {
            tag: 'Python',
            images: [
                Todo,
                Todo1,
                Todo2,
                Todo3,
                Todo4,
                Todo5
            ],
            title: 'Face Recognition System',
            caption: 'Deep learning thesis project',
            description: 'Developed deep learning model using ResNet50 and ArcFace for facial recognition. Improved accuracy and reduced bias in facial recognition systems. Master\'s thesis project.',
            links: [
                {
                link:'https://github.com/ab2230',
                icon: <GitHubIcon/>
                }
            ]
        }
    ]
}  